import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Icon, Modal, Spin, Table } from 'antd';
import { SVC_STATE } from '../../utils/constants';
import AuditRejectModal from './AuditRejectModal';
import './SvcDetailModal.less';
import { Btn } from '../Widgets';

const SVC_DETAIL_MODE = {
  audit: 'audit',
  detail: 'detail'
};

class SvcDetailModal extends PureComponent {
  static defaultProps = {
    visible: false,
    svcMeeting: {},
    mode: SVC_DETAIL_MODE.audit,
    onClose: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      rejectModal: false
    };
  }

  render() {
    const { visible, intl, svcMeeting, mode, loading } = this.props;
    const { rejectModal } = this.state;
    const { svcs } = svcMeeting;
    return (
      <Modal
        destroyOnClose={true}
        visible={visible}
        onCancel={this.closeHandle}
        title={
          mode === SVC_DETAIL_MODE.audit ? (
            <FormattedMessage id="audit_svc_audit" />
          ) : (
            <FormattedMessage id="audit_svc_detail" />
          )
        }
        wrapClassName="modal-close-header svc-detail-wrapper"
        width={600}
        footer={
          <div className="edit-footer">
            {mode === SVC_DETAIL_MODE.detail && (
              <Btn primary onClick={this.closeHandle}>
                <FormattedMessage id="btn_close" />
              </Btn>
            )}
            {mode === SVC_DETAIL_MODE.audit && (
              <Btn
                primary
                onClick={this.auditSvc.bind(this, SVC_STATE.agree, '')}
              >
                <FormattedMessage id="btn_approval" />
              </Btn>
            )}
            {mode === SVC_DETAIL_MODE.audit && (
              <Btn ghost onClick={() => this.setState({ rejectModal: true })}>
                <FormattedMessage id="btn_reject" />
              </Btn>
            )}
          </div>
        }
        closable
      >
        <Spin spinning={loading} size="large">
          <div className="service_detail_modal">
            <div className="row">
              <div className="left"><FormattedMessage id="service_level" />:</div>
              <div className="right">{svcMeeting.svc_level_name}</div>
            </div>
            <div className="row">
              <div className="left"><FormattedMessage id="service_item" />:</div>
              <div
                className="right"
                style={{ maxHeight: '470px', overflowY: 'auto' }}
              >
                <Table
                  columns={[
                    {
                      title:  intl.formatMessage({id: 'service_item_name'}),
                      key: 'serviceName',
                      width: '20%',
                      render: record => {
                        return <span>{record.name}</span>;
                      }
                    },
                    {
                      title: intl.formatMessage({id: 'service_item_type'}),
                      key: 'category',
                      width: '15%',
                      render: record => {
                        return <span>{record.type}</span>;
                      }
                    },
                    {
                      title: intl.formatMessage({id: 'meeting_service_apply_column_file'}),
                      key: 'dock',
                      width: '20%',
                      render: record => {
                        if (record.file) {
                          return (
                            <span
                              style={{ cursor: 'pointer', color: '#4680FF' }}
                              onClick={() => {
                                window.open(record.file);
                              }}
                            >
                              <Icon type="link" /> {record.fileName}
                            </span>
                          );
                        } else {
                          return <span>(无)</span>;
                        }
                      }
                    },
                    {
                      title: intl.formatMessage({id: 'meeting_service_apply_column_remark'}),
                      key: 'remark',
                      width: '25%',
                      render: record => {
                        return <span>{record.remark}</span>;
                      }
                    },
                    {
                      title: intl.formatMessage({id: 'meeting_service_apply_column_number'}),
                      key: 'number',
                      width: '20%',
                      render: record => {
                        return <span>{record.num}</span>;
                      }
                    }
                  ]}
                  dataSource={svcs}
                  rowKey={r => r.id}
                  pagination={false}
                />
              </div>
            </div>
          </div>
          <AuditRejectModal
            visible={rejectModal}
            onClose={() => this.setState({ rejectModal: false })}
            onSubmit={this.auditSvc.bind(this, SVC_STATE.reject)}
          />
        </Spin>
      </Modal>
    );
  }

  closeHandle = () => {
    const { onClose } = this.props;
    onClose && onClose();
  };

  auditSvc = (auditState, remark) => {
    const { onClose, svcMeeting, dispatch } = this.props;
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'svcAudit/auditSvc',
        meetingId: svcMeeting.id,
        auditState,
        remark,
        resolve,
        reject
      });
    });
    promise.then(
      () => {
        onClose && onClose();
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.loading.models['svcAudit']
  };
};

export default connect(mapStateToProps)(injectIntl(SvcDetailModal));



// WEBPACK FOOTER //
// ./src/components/AuditManage/SvcDetailModal.js